import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ProductRecommendation} from '../../models/product-recommendation.model';
import {ProductRecommendationService} from '../../providers/product-recommendation.service';
import {User} from '../../models/user.model';
import {PartnerProduct} from '../../models/partner-product.model';
import {ModalController} from '@ionic/angular';
import {GenericActionComponent, GenericActionComponentsMethods} from '../generic-action.component';
import {CommonUtils} from '../../utils/common';
import {AppStateService} from '../../providers/app-state.service';
import {TranslateService} from '@ngx-translate/core';
import {ItemFinderComponent} from '../item-finder/item-finder.component';
import {VetClinicService} from '../../providers/vet-clinic.service';
import {Client} from '../../models/client.model';
import {VetClinic} from '../../models/vet-clinic.model';
import {Subscription} from 'rxjs';
import {RecommendationDetailsCsvComponent} from '../recommendation-details-csv/recommendation-details-csv.component';
import {PartnerProductService} from '../../providers/partner-product.service';
import {ProductCategoriesForSpecies} from '../../models/product-categories-for-species.model';
import {ProductCategory} from '../../models/product-category.model';
import {
  VetPlanetCategoryProductModalComponent
} from '../vet-planet-category-product-modal/vet-planet-category-product-modal.component';

@Component({
  selector: 'app-edit-product-recommendation',
  templateUrl: './edit-product-recommendation.component.html',
  styleUrls: ['./edit-product-recommendation.component.scss'],
})
export class EditProductRecommendationComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input()
  productRecommendation: ProductRecommendation;
  @Input()
  appUser: User;
  isBusy: boolean;
  products: PartnerProduct[] = [];
  allProducts: PartnerProduct[] = [];
  partnerId: any = 256;
  clientSelected: Client;

  @Output() objectEditedEmitter = new EventEmitter<ProductRecommendation>();
  @Output() objectAddedEmitter = new EventEmitter<ProductRecommendation>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();
  isGeneralClientAdmin: boolean = true;
  isGeneralAdmin: boolean = true;
  userToRecommend: User;
  private isAdmin: boolean;
  clinics: VetClinic[];
  selectOptions: any = {
    header: 'Wybierz lecznicę'
  };
  clinicSelected: VetClinic;
  vetcodeId: string;
  private clinicSubs: Subscription;
  vetDoctorUUID: string;
  subscriptions: Subscription = new Subscription();
  categories: ProductCategoriesForSpecies[];
  segment: 'dog' | 'cat' = 'dog';
  currentCategories: ProductCategory[];
  currentlyRecommendedProducts: Set<PartnerProduct> = new Set();
  categoriesFiltered: boolean = false;


  constructor(private productRecommendationService: ProductRecommendationService,
              private modalController: ModalController,
              protected commonUtils: CommonUtils,
              private appStateService: AppStateService,
              private partnerProductService: PartnerProductService,
              private translateService: TranslateService,
              private vetClinicService: VetClinicService) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  onAction(): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit() {
    this.isAdmin = this.user.roles.split(';').filter(e => e === 'admin').length === 1;
    this.isGeneralClientAdmin = this.user.vClientId !== null && this.user.vetcodeId === null;
    this.isGeneralAdmin = this.user.vClientId === null && this.user.vetcodeId === null;
    if (this.user.vetcodeId) {
      this.vetcodeId = this.user.vetcodeId;
    }


    if (this.isAdmin) {
      this.appStateService.updateIsBusySubject(true);
      this.clinicSubs = this.vetClinicService.listClinicsForClient(this.user.vClientUUID).subscribe(e => {
        if (e) {
          this.clinics = e;
          if (this.clinics.length === 1) {
            this.clinicSelected = this.clinics[0];
            this.onSelectVetcode(this.clinicSelected.vetcodeId + '');
          }
          this.appStateService.updateIsBusySubject(false);
        } else {
          this.appStateService.updateIsBusySubject(false);
          this.commonUtils.presentAlertToast('Nie znaleziono lecznic dla podanego klienta');
        }
      });
    }

    this.registerSubscription(this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    }));


    if (this.vetcodeId && this.partnerId) {
      this.registerCategoriesAndProductsSubs();
    }


    if (this.action === 'EDIT') {

      this.userToRecommend = this.productRecommendation.user;
      this.clinicSelected = this.productRecommendation.vetClinic;
      this.currentlyRecommendedProducts = new Set<PartnerProduct>(this.productRecommendation.products);
    }

    super.ngOnInit();
  }


  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }


  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }

  removeProduct(product: PartnerProduct) {
    this.currentlyRecommendedProducts.delete(product);
  }

  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : ''
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clinicSelected = null;
        this.vetcodeId = null;
        this.clientSelected = data.data;
        this.appStateService.updateIsBusySubject(true);
        this.clinicSubs = this.vetClinicService.listClinicsForClient(this.clientSelected.uuid).subscribe(e => {
          if (e) {
            this.clinics = e;
            if (this.clinics.length === 1) {
              this.clinicSelected = this.clinics[0];
              this.onSelectVetcode(this.clinicSelected.vetcodeId + '');
            }
            this.appStateService.updateIsBusySubject(false);
          } else {
            this.appStateService.updateIsBusySubject(false);
            this.commonUtils.presentAlertToast('Nie znaleziono lecznic dla podanego klienta');
          }
        });
      }
    });

    return await modal.present();
  }


  onSelectVetcode(vetcode: string) {
    this.vetcodeId = vetcode;
    this.clinics?.forEach(clinic => {
      if (clinic.vetcodeId === parseInt(this.vetcodeId)) {
        this.clinicSelected = clinic;
        this.partnerId = this.clinicSelected.partnerVClientId;
      }
    });

    this.appStateService.updateIsBusySubject(true);
    this.registerCategoriesAndProductsSubs();

  }


  getSelectedText() {
    if (this.clinicSelected && this.clinics && this.clinics.length > 1) {
      const sameNameClinicExists = this.clinics.some(c => this.clinicSelected.clinicName === c.clinicName);
      if (sameNameClinicExists) {
        return this.commonUtils.getClinicNameWithAddress(this.clinicSelected);
      }
    }
    if (this.clinicSelected) {
      return this.clinicSelected.clinicName;
    } else {
      return '';
    }
  }

  onSelectClinic($event: any) {
    if ($event.detail.value) {
      this.onSelectVetcode($event.detail.value.vetcodeId);
    }
  }

  async onSubmit() {
    const modal = await this.modalController.create({
      component: RecommendationDetailsCsvComponent,
      componentProps: {
        products: [...this.currentlyRecommendedProducts]
      }
    });

    modal.onWillDismiss().then(data => {
    });

    modal.present();
  }

  onSegmentChange($event: any) {
    this.segment = $event.detail.value;
    this.updateCurrentCategories();
  }

  updateCurrentCategories() {
    this.currentCategories = this.categories.find(
      value => value.species.toUpperCase() === this.segment.toUpperCase()
    )?.categories.sort((a, b) => a.order - b.order) ?? [];
  }

  async openProductsFromCategoryModal(innerCategory: ProductCategory, category: ProductCategory) {

    const categoryTags: string[] = [];
    this.segment === 'dog' ? categoryTags.push('Pies') : categoryTags.push('Kot');
    categoryTags.push(category.name);
    categoryTags.push(innerCategory.name);
    const matchingProducts = this.allProducts.filter(partnerProduct =>
      categoryTags.every(tag => partnerProduct.categoriesJson?.includes(tag))
    );
    console.log('MATCHING ', matchingProducts);
    const modal = await this.modalController.create({
      component: VetPlanetCategoryProductModalComponent,
      componentProps: {
        productsInCart: this.currentlyRecommendedProducts,
        products: matchingProducts,
        categoryTags,
      }
    });

    modal.onWillDismiss().then(data => {

    });
    return await modal.present();
  }

  filterCategoriesWithoutProducts() {

    const allTopCategories = this.categories;

    for (const topCategory of allTopCategories) {

      for (const outerCategory of topCategory.categories) {

        let fullOuterCategoryEmpty = true;

        for (const innerCategory of outerCategory.categories) {
          const categoryTags: string[] = [];
          topCategory.species.toUpperCase() === 'DOG' ? categoryTags.push('Pies') : categoryTags.push('Kot');
          categoryTags.push(outerCategory.name);
          categoryTags.push(innerCategory.name);
          const matchingProducts = this.allProducts.filter(partnerProduct =>
            categoryTags.every(tag => partnerProduct.categoriesJson?.includes(tag))
          );
          if (matchingProducts.length === 0) {
            innerCategory.empty = true;
          } else {
            fullOuterCategoryEmpty = false;
          }
        }
        if (fullOuterCategoryEmpty) {
          outerCategory.empty = true;
        }
      }
    }
    this.categoriesFiltered = true;

  }

  private registerCategoriesAndProductsSubs() {
    console.log('registerCategoriesAndProductsSubs')
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.partnerProductService.getCategoriesConfig(this.vetcodeId).subscribe(async categoriesJsonString => {
      if (categoriesJsonString) {
        this.categories = JSON.parse(categoriesJsonString);
        this.updateCurrentCategories();
        this.handleProducts();

      } else {
        this.categories = await this.partnerProductService.getCategories().toPromise();

        this.updateCurrentCategories();
        this.handleProducts();
      }
      this.appStateService.updateIsBusySubject(false);
    }, async error => {
      this.categories = await this.partnerProductService.getCategories().toPromise();
      this.updateCurrentCategories();
      this.handleProducts();

      this.appStateService.updateIsBusySubject(false);
    }));




  }

  handleProducts() {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.partnerProductService.getAllPartnerProducts(this.partnerId).subscribe(prod => {
      if (prod) {
        this.allProducts = prod;
        this.filterCategoriesWithoutProducts();

      }
      this.appStateService.updateIsBusySubject(false);

    }, error => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }

  checkIfNoProductsInCurrentCategories() {

    if (this.currentCategories.length === 0) {
      return false;
    }
    for (const category of this.currentCategories) {
      for (const innerCategory of category.categories) {
        if (!innerCategory.empty) {
          return false;
        }
      }
    }
    return true;
  }

}
